// extracted by mini-css-extract-plugin
module.exports = {"container":"jsbridge_container__ZUR7G","modal":"jsbridge_modal__affnJ","canvasExample":"jsbridge_canvasExample__21akb"};